import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { ReactChild } from "react";

type ReactTableExpandableCellProps = {
  row: any;
  canExpand?: boolean;
  expandedColor?: string;
  children?: ReactChild;
};

const ReactTableExpandableCell = ({
  row,
  canExpand = true,
  expandedColor = "var(--steel)",
  children,
}: ReactTableExpandableCellProps) => {
  return (
    <div
      className={classNames(
        "cell__content--horizontal",
        "cell__content--noWrapFlex",
        "expandableCell",
        {
          "expandableCell--cursor": canExpand,
        }
      )}
      style={{ color: canExpand && row.isExpanded ? expandedColor : undefined }}
      {...row.getToggleRowExpandedProps}
    >
      {children}
      {canExpand &&
        (row.isExpanded ? (
          <FontAwesomeIcon icon="angle-down" />
        ) : (
          <FontAwesomeIcon icon="angle-right" />
        ))}
    </div>
  );
};

export default ReactTableExpandableCell;
